import {AppEventType} from './app-event-type.enum';

export class AppEvent<T> {
  constructor(
    public name: AppEventType,
    public type: T,
    public payload: any
  ) {}
}
